import { render, staticRenderFns } from "./ModalEditarEmailAniversario.vue?vue&type=template&id=3de0e6f7&"
import script from "./ModalEditarEmailAniversario.vue?vue&type=script&lang=js&"
export * from "./ModalEditarEmailAniversario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports